export default function  Value (){
   
   
    return (
        <div className="container--big-row">
        <div className="quality-container">
        <div className="content--description right-description">
            <h3 className="content-section--2title special-color content--text-right ">VALUES</h3>
            <h1 className="content-section--1title content--text-right">At <span className="special-color-1"> Meow Hosting </span></h1>
            <p className="content-section--para content-section--para-left">we're dedicated to delivering exceptional value with every hosting plan. Our feature-rich packages provide you with more than just web space.</p>
             <div className="value-list">
                <div className="value-item">
                    <div className="value-item-group">
                         <div className="value-icon value-blue"><i class="fa-solid fa-globe"></i></div> 
                         <h2 className="steps--title">Advanced Tech</h2>
                    </div>
                    <p>We offer the tools, security, and support you need to thrive online.</p>
                </div>
                <div className="value-item">
                    <div className="value-item-group">
                   <div  className="value-icon value-green"><i class="fa-solid fa-money-bill-wave"></i></div> 
                        <h2 className="steps--title">Profitable Website</h2>
                    </div>
                    <p>Experience the perfect balance of affordability and performance as you unlock a world of possibilities for your website, all backed by our unwavering commitment to your success.</p>
                </div>

             </div>
            <div className="button-space"><button className="btn no-cursor">Learn More</button></div>
        </div>
<figure className="content--img-container"><img  src="undraw_image_post_re_25wd.svg"/></figure>

        </div>
        </div>
        
        )
}